export { default } from './BorrowingHeader';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingHeader/index.js